<template>
  <div class="question-container">
    <!-- PREVIEW MODE -->
    <div v-if="mode == 0">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
        </div>

        <div class="col-md-7">
          <template v-if="answer && answer.answerText">
            <div>{{ answer[JsonFieldToDisplay()] }}</div>
          </template>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- EDIT MODE -->
    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="question.isSkippable">Optional</span>
          <span v-if="isQuestionSkipped()" class="skipped-question-box ml-15 d-inline-box pt-2">
            Skipped
          </span>
        </div>
        <div class="col-md-7" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <div v-if="question.direction.toLowerCase() === 'horizontal'">
            <div v-if="surveyData && surveyData.newLayout == true">
              <div class="row">
                <div class="col-md-3 pr-10">{{ question.minValueLabel }}</div>
                <div class="col-md-6">
                  <ds-slider
                    :ref="`slider-${question.id}`"
                    :value="answer && answer.answerText"
                    direction="horizontal"
                    class="horizontal-vue-slider pt-20"
                    :width="displayMobileView ? question.restrainLengthValue + 'px' : question.restrainLengthValue + 'mm'"
                    :min="question.minValue"
                    :max="question.maxValue"
                    :disabled="answer && answer.isDisabled ? true : false"
                    :dotSize="answer.isSkipped ? 0 : 10"
                    :tooltip="answer.isSkipped ? false : 'always'"
                    :clickable="false"
                    @drag-start="refreshScale(question.id)"
                    :interval="question.partitions"
                    @input="onSliderValueChange($event)"
                  >
                  </ds-slider>
                  <div class="pt-10 scaleLabels-vas">
                    <span :style="{ 'margin-left': 15 + 'px' }">{{ question.minValue }}</span>
                    <span class="pull-right">{{ question.maxValue }}</span>
                  </div>
                </div>
                <div class="col-md-3">{{ question.maxValueLabel }}</div>
              </div>
            </div>
            <div v-else>
              <div
                class="d-flex justify-content-between pl-5 pr-5"
                :style="{
                  width: displayMobileView ? question.restrainLengthValue + 'px' : question.restrainLengthValue + 'mm'
                }"
              >
                <span>{{ question.minValueLabel }}</span>
                <span>{{ question.maxValueLabel }}</span>
              </div>
              <ds-slider
                :ref="`slider-${question.id}`"
                :value="answer && answer.answerText"
                direction="horizontal"
                class="horizontal-vue-slider pt-20"
                :width="displayMobileView ? question.restrainLengthValue + 'px' : question.restrainLengthValue + 'mm'"
                :min="question.minValue"
                :max="question.maxValue"
                :disabled="answer && answer.isDisabled ? true : false"
                :dotSize="answer.isSkipped ? 0 : 10"
                :tooltip="answer.isSkipped ? false : 'always'"
                :clickable="false"
                @drag-start="refreshScale(question.id)"
                :interval="question.partitions"
                @input="onSliderValueChange($event)"
              >
              </ds-slider>
              <div
                class="d-flex justify-content-between pl-5 pr-5"
                :style="{
                  width: displayMobileView ? question.restrainLengthValue + 'px' : question.restrainLengthValue + 'mm'
                }"
              >
                <span>{{ question.minValue }}</span>
                <span>{{ question.maxValue }}</span>
              </div>
            </div>
          </div>
          <div v-else-if="question.direction.toLowerCase() === 'vertical'">
            <div class="d-flex">
              <span style="flex: 0 0 30px;">{{ question.maxValue }}</span>
              <span class="pl-15">{{ question.maxValueLabel }}</span>
            </div>
            <ds-slider
              :ref="`slider-${question.id}`"
              :value="answer && answer.answerText"
              direction="vertical"
              :min="question.minValue"
              :max="question.maxValue"
              :disabled="answer && answer.isDisabled ? true : false"
              :height="`${question.restrainLengthValue}mm`"
              :width="5"
              class="vertical-vue-slider pl-30"
              :dotSize="answer.isSkipped ? 0 : 10"
              :tooltip="answer.isSkipped ? false : 'always'"
              :clickable="false"
              :interval="question.partitions"
              @drag-start="refreshScale(question.id)"
              @input="onSliderValueChange($event)"
            >
            </ds-slider>
            <div class="d-flex">
              <span style="flex: 0 0 30px;">{{ question.minValue }}</span>
              <span class="pl-15">{{ question.minValueLabel }}</span>
            </div>
          </div>
          <span v-if="hasFieldError" class="text-danger">
            <p>{{ fieldErrorText }}</p>
          </span>
          <span v-else-if="hasFieldWarning" class="text-warning">
            <p>{{ fieldWarningText }}</p>
          </span>
        </div>
        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- RESPONSE MODE -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="answer && answer.edit_status == 1"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <template v-if="answer && answer.answer_text">
              <div class="col-md-12 d-flex pl-30">
                <span class="text-align">{{ selectedLanguageCulture == "EN" ? answer.answer_text : answer.display_answer_text }}</span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-25 pt-10" v-if="showScore && activityType == 'activity' && answer.score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="answer && answer.edit_status == 1">
          <div>
            <span class="previous-value-mark"></span>
            <div class="previous-value ml-3">PREVIOUS RESPONSE</div>

            <template v-if="answer && answer.privius_answer_text">
              <div>
                <span class="text-align">{{ selectedLanguageCulture == "EN" ? answer.privius_answer_text : answer.privius_display_answer_text }}</span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-0 pt-10" v-if="showScore && answer.privius_score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.privius_score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
import dsSlider from "../../../../lib/ds-slider-component";
import * as constant from "@/constants/config";

export default {
  name: "VASResponse",
  mixins: [activityCommonMixin],
  data() {
    return {
      updatedAns: this.answer && this.answer.answerText,
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: "",
      displayMobileView: Boolean
    };
  },
  components: {
    dsSlider
  },
  props: {
    mode: Number,
    answer: Object,
    surveyData: Object,
    question: Object,
    usage: Object,
    stepIndex: Number,
    selectedLanguageCulture: String,
    activityType: String
  },
  created() {
    if (constant.SCREENWIDTH > 1200) {
      this.displayMobileView = false;
    } else {
      this.displayMobileView = true;
    }
  },
  watch: {
    hasFieldError(val) {
      this.question.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.question.fieldErrorText = val;
    }
  },
  methods: {
    isSkippable(question) {
      return question.isSkipped || question.isSkippable;
    },
    onSliderValueChange(value) {
      if (this.isQuestionSkipped()) {
        return;
      }
      this.updatedAns = `${value}`;
      this.checkForFieldErrors();

      if (this.answer && !this.hasFieldError) {
        this.$set(this.answer, "score", this.updatedAns);
        this.$set(this.answer, "computedScore", this.updatedAns);
      }

      this.$emit(`answerChanged`, {
        questionId: this.question.id,
        newAns: this.updatedAns
      });
    },
    refreshScale(questionId) {
      const ref = `slider-${questionId}`;
      this.$nextTick(() => {
        this.$refs[ref].refresh();
      });
    },
    checkForFieldErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";

      const { dataEditChecks } = this.question;
      this.question.dataChecks = [];

      if (dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "NOT_BLANK" && this.updatedAns == false) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `This field is required.`;
              this.question.isSkippable = true;
              softDataCheck = true;
              this.question.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              return false;
            }
          } else {
            if (dataEditChecks[k].type == "NOT_BLANK" && this.updatedAns == false) {
              this.question.isSkippable = false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
      if (!this.question.isSkippable && !!this.updatedAns == false) {
        this.hasFieldError = true;
        this.fieldErrorText = "This field is required.";
      } else if (this.question.isSkippable && !!this.updatedAns == false) {
        this.hasFieldWarning = true;
        this.fieldWarningText = "This field is required.";
      }
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}
.question-text {
  display: inline;
}

.previous-value-mark {
  width: 9px;
  height: 51px;
  background-color: #f5a623;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.previous-value {
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #f5a623;
  margin-bottom: 9px;
  margin-top: 3px;
}

.answers {
  font-weight: 600;
  color: #000000;
}
</style>
